import { useCustomViewDialogStore } from "csi/middleware/customView/CustomViewDialogStore";
import CheckboxOption from "csi/middleware/customView/options/CheckboxOption";
import CustomViewOptionCustomSection from "csi/middleware/customView/options/CustomViewOptionCustomSection";
import DisplayCommentLines from "csi/middleware/customView/options/DisplayCommentLines";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import BOMCustomViewOptionsStore from "./BOMCustomViewOptionsStore";

const BOMViewOptions: FunctionComponent = observer(function BOMViewOptions() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		options,
		setCompareToTheme,
		setDisplayColorImages,
		setDisplayCommentLines, 
		setDisplaySupplierCodes,
		toggleCollapsedViewSpecificOptions,
		viewSpecificOptionsCollapse,
	} = optionsStore as BOMCustomViewOptionsStore;

	const {
		compareToTheme,
		displayColorImages,
		displayCommentLines,
		displaySupplierCodes,
	} = options;

	return (
		<CustomViewOptionCustomSection
			collapsed={viewSpecificOptionsCollapse}
			dataCsiAutomation="CustomViewBOMOptions"
			onCollapse={toggleCollapsedViewSpecificOptions}
			titleRes="CustomViewBOMOptions"
		>
			<CheckboxOption
				dataCsiAutomation="CompareToTheme"
				label="ViewPreferences_compareToTheme"
				onChange={setCompareToTheme}
				optionValue={compareToTheme}
				paddingLeft={0}
			/>
			<DisplayCommentLines
				onChange={setDisplayCommentLines}
				value={displayCommentLines}
			/>
			<CheckboxOption
				dataCsiAutomation="CustomViewBOMDisplayColorImages"
				label="CustomViewBOMDisplayColorImages"
				onChange={setDisplayColorImages}
				optionValue={displayColorImages}
				paddingLeft={0}
			/>
			<CheckboxOption
				dataCsiAutomation="CustomViewBOMSupplierCodes"
				label="CustomViewBOMSupplierCodes"
				onChange={setDisplaySupplierCodes}
				optionValue={displaySupplierCodes}
				paddingLeft={0}
			/>
		</CustomViewOptionCustomSection>
	);
});

export default BOMViewOptions;